var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { useState, Fragment, PureComponent } from 'react';
import AccordionWidget from '../AccordionWidget';
import Input from '../../components/Input';
import Button from '../../components/Button';
import List from '../../components/List';
import { FormattedRelativeTime } from 'react-intl';
import getByPath from 'lodash/get';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import { getKycType } from '../Verify/types';
import { getKycReason } from '../Verify/reasons';
import { getKycStatus } from '../Verify/status';
import { selectUnit } from '../../lib/utils/selectUnit';

var UploadForm = function UploadForm(_ref) {
  var type = _ref.type,
      onSubmit = _ref.onSubmit;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  return React.createElement(
    Fragment,
    null,
    React.createElement(Input, {
      id: 'KycImage_' + type,
      name: 'Image',
      type: 'file',
      style: { display: 'none' },
      onChange: function onChange(e) {
        if (!e.target.files[0]) return;
        setIsLoading(true);
        onSubmit({
          Type: type,
          Image: e.target.files[0],
          doneCallback: function doneCallback() {
            return setIsLoading(false);
          },
          errorCallback: function errorCallback() {
            setIsLoading(false);
          }
        });
      }
    }),
    React.createElement(
      Button,
      {
        isLoading: isLoading,
        'for': 'KycImage_' + type,
        className: 'button primary wide' },
      React.createElement(Translate, {
        defaultMessage: 'Upload document',
        id: 'button.upload_document'
      })
    )
  );
};

var KYCList = function KYCList(_ref2) {
  var data = _ref2.data;
  return React.createElement(
    'div',
    null,
    React.createElement(List, {
      data: data.map(function (item, id) {
        return {
          id: id,
          info: [[React.createElement(
            'div',
            { className: 'bold' },
            getKycType(item.Type)
          ), getKycStatus(item.Status)], [React.createElement('div', { className: 'space' }), React.createElement(FormattedRelativeTime, selectUnit(new Date(item.Added + '+00:00')))]],
          detail: [[React.createElement(Translate, { id: 'label.comment', defaultMessage: 'Comment' }), React.createElement(Translate, { id: 'label.reasons', defaultMessage: 'Reasons' })], [item.Comment ? React.createElement(
            'span',
            null,
            item.Comment
          ) : React.createElement(Translate, { id: 'label.none', defaultMessage: 'None' }), item.Reasons.length ? React.createElement(
            'div',
            { className: 'column' },
            item.Reasons.map(function (reason) {
              return getKycReason(reason);
            })
          ) : React.createElement(Translate, { id: 'label.none', defaultMessage: 'None' })]]
        };
      })
    })
  );
};

var VerifyAccordionWidget = function (_PureComponent) {
  _inherits(VerifyAccordionWidget, _PureComponent);

  function VerifyAccordionWidget() {
    _classCallCheck(this, VerifyAccordionWidget);

    return _possibleConstructorReturn(this, (VerifyAccordionWidget.__proto__ || Object.getPrototypeOf(VerifyAccordionWidget)).apply(this, arguments));
  }

  _createClass(VerifyAccordionWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          data = _props.data,
          onSubmit = _props.onSubmit,
          children = _props.children;


      items = items && items.map(function (item) {
        return _extends({}, item, {
          content: React.createElement(
            Fragment,
            null,
            typeof children === 'function' ? children({ item: item, onSubmit: onSubmit }) : React.createElement(
              Fragment,
              null,
              React.createElement('p', { dangerouslySetInnerHTML: { __html: item.content } }),
              React.createElement(UploadForm, {
                type: getByPath(item, 'config.Type'),
                onSubmit: onSubmit
              })
            ),
            data && React.createElement(KYCList, {
              data: data.filter(function (x) {
                return x.Type === getByPath(item, 'config.Type');
              })
            })
          )
        });
      });

      return React.createElement(
        'div',
        { className: 'VerifyAccordionWidget' },
        items && React.createElement(AccordionWidget, {
          items: items,
          initialExpandedIndex: items.findIndex(function (i) {
            return i.expanded;
          })
        })
      );
    }
  }]);

  return VerifyAccordionWidget;
}(PureComponent);

VerifyAccordionWidget.propTypes = {
  /** The submission function firing when submitting the form */
  onSubmit: PropTypes.func,
  /** A collection of kyc items as sections */
  items: PropTypes.array,
  /** Player kyc data */
  data: PropTypes.array
};

VerifyAccordionWidget.defaultProps = {
  onSubmit: function onSubmit() {},
  items: [],
  data: []
};

export default VerifyAccordionWidget;